/**
 * Component common-menu-mobile JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.common-menu-mobile');
    
    if (!component.length) {
        return;
    }

    jQuery('a', component).bind('click', function (e) {

        jQuery('.header-default__primary-icon a').click();
    });
});